import React from 'react';
import {
    DashboardOutlined,
    FileTextOutlined,
    UserOutlined,
    SettingOutlined,
    TeamOutlined,
    WalletOutlined,
    BarChartOutlined,
    SafetyOutlined,
    KeyOutlined,
    GlobalOutlined,
    MessageOutlined,
    QrcodeOutlined,
    LogoutOutlined,
    LoginOutlined,
    HomeOutlined,
    ShopOutlined,
    CreditCardOutlined,
    TransactionOutlined,
    AuditOutlined,
    ToolOutlined,
} from '@ant-design/icons';

// 图标映射表
export const iconMap: Record<string, React.ComponentType<any>> = {
    // 基础图标
    dashboard: DashboardOutlined,
    fileText: FileTextOutlined,
    user: UserOutlined,
    setting: SettingOutlined,
    team: TeamOutlined,
    wallet: WalletOutlined,
    barChart: BarChartOutlined,
    safety: SafetyOutlined,
    key: KeyOutlined,
    global: GlobalOutlined,
    message: MessageOutlined,
    qrcode: QrcodeOutlined,
    logout: LogoutOutlined,
    login: LoginOutlined,
    home: HomeOutlined,
    shop: ShopOutlined,
    creditCard: CreditCardOutlined,
    transaction: TransactionOutlined,
    audit: AuditOutlined,
    tool: ToolOutlined,

    // 业务相关图标映射
    order: FileTextOutlined,
    pledge: WalletOutlined,
    balance: BarChartOutlined,
    withdrawal: CreditCardOutlined,
    merchant: ShopOutlined,
    system: SettingOutlined,
    admin: SafetyOutlined,
    qr: QrcodeOutlined,
    chat: MessageOutlined,
    welcome: HomeOutlined,

    // 更多业务图标
    payment: CreditCardOutlined,
    finance: WalletOutlined,
    report: BarChartOutlined,
    config: SettingOutlined,
    security: SafetyOutlined,
    notification: MessageOutlined,
    profile: UserOutlined,
    management: ToolOutlined,
    analytics: BarChartOutlined,
    settings: SettingOutlined,

    // 常见英文图标名称
    'file-text': FileTextOutlined,
    'bar-chart': BarChartOutlined,
    'credit-card': CreditCardOutlined,
    'qr-code': QrcodeOutlined,
    'google-2fa': SafetyOutlined,
    'two-factor': SafetyOutlined,
    '2fa': SafetyOutlined,
    'google2fa': SafetyOutlined,
    'google2FA': SafetyOutlined,
    'google_2fa': SafetyOutlined,
    'google_2FA': SafetyOutlined,
};

// 类型转换函数：将 MenuRoute 转换为 MenuDataItem
export const convertMenuRouteToMenuDataItem = (menuRoute: API.MenuRoute): any => {
    // 获取图标组件
    let iconComponent = undefined;
    if (menuRoute.icon) {
        const iconName = menuRoute.icon;
        if (iconMap[iconName]) {
            const IconComponent = iconMap[iconName];
            iconComponent = React.createElement(IconComponent);
        } else {
            // 尝试使用默认图标
            iconComponent = React.createElement(FileTextOutlined);
        }
    }

    return {
        path: menuRoute.path,
        name: menuRoute.name,
        icon: iconComponent,
        component: menuRoute.component,
        access: menuRoute.access,
        redirect: menuRoute.redirect,
        layout: menuRoute.layout,
        routes: menuRoute.routes ? menuRoute.routes.map(convertMenuRouteToMenuDataItem) : undefined,
        // 确保包含必要的字段
        hideInMenu: false,
        hideChildrenInMenu: false,
        flatMenu: false,
    };
};
